import React from "react";
import { ControlledCustomSelect } from "../formsComponents";

export interface IPriorityFilterProps {
  value: string;
  onChange: (value: string) => void;
  isHighlighted?: boolean;
  isFilter?: boolean;
}

export const PriorityFilter: React.FC<IPriorityFilterProps> = (props) => {
  const { value, isHighlighted, onChange, isFilter } = props;

  const options = isFilter
    ? [
        { label: "All", value: "" },
        { label: "Hot", value: "HOT" },
        { label: "Cold", value: "COLD" },
      ]
    : [
        { label: "Hot", value: "HOT" },
        { label: "Cold", value: "COLD" },
      ];

  return (
    <ControlledCustomSelect
      label="Priority"
      labelId="priority"
      fullWidth
      clearable={isFilter ? !!value : false}
      placeholder={isFilter ? "All" : undefined}
      InputLabelProps={isFilter ? { shrink: true } : undefined}
      notched={isFilter ? true : undefined}
      highlight={isHighlighted}
      sx={{ minWidth: "90px" }}
      displayEmpty
      value={value}
      options={options}
      onChange={(e) => onChange(e.target.value as string)}
      onClear={() => onChange("")}
    />
  );
};
